var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('DynamicList',{ref:"dynamicCardList",attrs:{"searchFormStructure":_vm.dataSearchFormStructure,"columns":_vm.dataColumns,"edit":_vm.dataEdit,"onRetrieve":_vm.onRetrieve,"root":"/report/commerce-stocks","searchArgs":_vm.searchArgs}},[_vm._t("default",[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.$refs.modalExport.open = true}}},[_vm._v("\n                "+_vm._s(_vm.Core.Definition.getDefinition("Exporter sous format ..."))+"\n            ")]),_c('ModalExport',{ref:"modalExport",attrs:{"root":"/report/commerce-stocks","formStructure":{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportFormat'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                 {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'id'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'type'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'stockManagement'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'stockQuantity'
                                                }
                                            ]
                                        },
                                        {
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'exportFormat',
                                    type: 'select',
                                    options: _vm.Core.Export.formatOptions(),
                                    label: _vm.Core.Definition.getDefinition('Format'),
                                    value: null,
                                    onSelect: function() {}
                                },
                                {
                                    id: 'exportTitle',
                                    type: 'text',
                                    label: _vm.Core.Definition.getDefinition('Titre'),
                                    value: '',
                                    required: true
                                },
                                {
                                    id: 'id',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('ID'),
                                    value: true,
                                    export: 'id',
                                    onChange: function() {}
                                },
                                {
                                    id: 'stockManagement',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Gestion des stocks activées'),
                                    value: true,
                                     export: 'stockManagement',
                                    onChange: function() {}
                                },
                                {
                                    id: 'type',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Type de produit'),
                                    value: true,
                                     export: 'type',
                                    onChange: function() {}
                                },
                                {
                                    id: 'title',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Titre'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'title',
                                    onChange: function() {}
                                },
                                {
                                    id: 'stockQuantity',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Quantité'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'stockQuantity',
                                    onChange: function() {}
                                }
                            ]}},on:{"onSubmit":_vm.onExport}})],{"slot":"afterSearchForm"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }